import { useEffect } from 'react'
import { LogOut } from 'lucide-react'

/** Hauteur de la bannière staging (partagée avec la nav via CSS var). */
export const STAGING_BANNER_HEIGHT = '2.5rem'
export const STAGING_BANNER_CSS_VAR = '--ng-staging-banner-height'

/**
 * Bannière fixe en haut du site en environnement staging.
 * @param {{ onLogout: () => void }} props
 */
export default function StagingBanner({ onLogout }) {
  useEffect(() => {
    const root = document.documentElement
    root.style.setProperty(STAGING_BANNER_CSS_VAR, STAGING_BANNER_HEIGHT)
    root.dataset.stagingBanner = 'true'

    return () => {
      root.style.removeProperty(STAGING_BANNER_CSS_VAR)
      delete root.dataset.stagingBanner
    }
  }, [])

  return (
    <div
      role="status"
      className="fixed top-0 left-0 right-0 z-[55] flex h-10 items-center justify-between gap-3 bg-amber-600 px-3 text-white shadow-md sm:px-4"
      style={{ height: STAGING_BANNER_HEIGHT }}
    >
      <p className="min-w-0 truncate text-xs font-semibold tracking-wide sm:text-sm">
        <span className="mr-1.5 inline-block h-1.5 w-1.5 shrink-0 rounded-full bg-white/90 align-middle" aria-hidden="true" />
        Environnement de staging — site de développement
      </p>
      <button
        type="button"
        onClick={onLogout}
        className="inline-flex shrink-0 items-center gap-1.5 rounded-full border border-white/30 bg-white/10 px-3 py-1 text-xs font-semibold text-white transition-colors hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-white/60 focus:ring-offset-2 focus:ring-offset-amber-600 sm:text-sm"
      >
        <LogOut className="h-3.5 w-3.5" aria-hidden="true" />
        Déconnexion
      </button>
    </div>
  )
}
